if (document.body.classList.contains('woocommerce-order-received')) {
  const orderInfo = document.getElementById('order-information');
  const crossSell = document.querySelector('.woocommerce-order .cross-sells');
  if (orderInfo && crossSell) {
    const { orderExpireAt } = orderInfo.dataset;
    const countDownTo = new Date(orderExpireAt).getTime();
    const heading = crossSell.querySelector('h2');
    const popupCountdownContainers = Array.from(document.querySelectorAll('.popup .kos-popup-countdown'));
    let now = new Date().getTime();

    if (countDownTo - now < 1) {
      window.location = `https://${window.location.hostname}/`;
    }

    const countdown = setInterval(() => {
      now = new Date().getTime();
      const distance = countDownTo - now;

      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let output = '';

      if (minutes > 0) {
        if (minutes > 1) {
          output = `Du har ${minutes} minutter og ${seconds} sekunder på å legge til noe i bestillingen din`;
        } else {
          output = `Du har ${minutes} minutt og ${seconds} sekunder på å legge til noe i bestillingen din`;
        }
      } else {
        output = `Du har ${seconds} sekunder på å legge til noe i bestillingen din`;
      }

      heading.innerHTML = output;

      popupCountdownContainers.forEach((countdownContainer) => {
        // eslint-disable-next-line no-param-reassign
        countdownContainer.innerHTML = output;
      });

      if (distance < 0) {
        clearInterval(countdown);
        window.location = `https://${window.location.hostname}/`;
      }
    }, 1000);
  }

  const togglePopups = Array.from(document.querySelectorAll('a.kus-toggle-popup'));
  if (togglePopups.length > 0) {
    togglePopups.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const { parentNode } = button;
        const popupWindow = parentNode.querySelector('.popup');
        popupWindow.classList.toggle('open');
      });
    });
  }
}
